module.exports = __webpack_public_path__ + "notify_new_styles.31b80dc5b89ce31ab4bfa7e3e2619313.svg";